import React from "react";
import { routes, loginRoutes } from "./routes";
import { Routes, Route, useLocation } from "react-router-dom";
import { Box, Snackbar, useMediaQuery } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Alert from "@mui/material/Alert";
import { showModal, showToast } from "../store/slices/common";
import Modal from "../components/Modal";
import { getModalProps } from "../components/Modal/Modalutils";
import { getAccessToken } from "../utils/auth-token-utils/cookie";
import Sidebar from "../components/SidebarComponent";
import { useTheme } from "@emotion/react";


const getRoutes = (accessToken, smScreen, mdScreen) => {
  if (accessToken) {
    return (
      <Box
        sx={{
          height: "100%",
          width: "100%",
          margin: "0",
          padding: "0",
          boxSizing: "border-box",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Sidebar smScreen={smScreen} mdScreen={mdScreen} />
        <Routes>
          {loginRoutes.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={route.element()}
            />
          ))}
        </Routes>
      </Box>
    );
  } else
    return (
      <Routes>
        {routes.map((route) => (
          <Route key={route.path} path={route.path} element={route.element()} />
        ))}
      </Routes>
    );
};

export default function RootView() {
  const dispatch = useDispatch();
  const theme = useTheme();
  const locationState = useLocation();
  const token = getAccessToken();
  const { toaster, modal } = useSelector((state) => state.common);
  const smScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const mdScreen = useMediaQuery(theme.breakpoints.down("md"));
  const accessToken = locationState?.state?.token || token;

  const closeToast = () => {
    setTimeout(() => {
      dispatch(showToast(null));
    }, 500);
  };

  const handleModalClose = () => {
    dispatch(showModal(null));
  };

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={Boolean(toaster)}
        autoHideDuration={4000}
        onClose={closeToast}
      >
        {toaster && (
          <Alert onClose={closeToast} severity={toaster.color}>
            {toaster.msg}
          </Alert>
        )}
      </Snackbar>
      {Boolean(modal) && (
        <Modal
          open={Boolean(modal)}
          handleClose={handleModalClose}
          {...getModalProps(modal)}
        />
      )}
      {getRoutes(accessToken, smScreen, mdScreen)}
    </>
  );
}
